interface Prop {
  children?: React.ReactNode;
}

export const SideBarContainer: React.FC<Prop> = ({ children }) => {
  return (
    <div className="col-span-1 flex flex-col h-full border-r border-green-500 bg-white">
      {children}
    </div>
  );
};
